/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeApplyLeafSpecRuleId } from './workingModeApplyLeafSpecRuleId';

/**
 * One leaf in a working-mode apply background job (essay rubric or oral pool).
 */
export interface WorkingModeApplyLeafSpec {
  taskId: string;
  taskTitle: string;
  ruleId?: WorkingModeApplyLeafSpecRuleId;
}
